import Backbone from 'backbone'
import template from './scorecards-advanced-form.hbs'
import DateInput from 'scoreboard/components/date-input'
import _ from 'lodash'
import FormView from 'scoreboard/components/form-view'
import formHelper from 'scoreboard/components/form-helper'
import * as dateRangeValidator from 'scoreboard/components/validators/date-range-validator-factory'
import TagsChooser from 'scoreboard/components/tags-chooser'
import selects from 'scoreboard/components/selects'

/**
 * @property model is the original un-edited model of a ScorecardNode
 */
var ScorecardsAdvancedForm = Backbone.View.extend({

	tagName: 'form',

	className: 'form scorecards-advanced-form',

	events: {
		'change [name=useTemplateDates]': 'toggleUseTemplateDates'
	},

	/**
	 * @param options
	 * @param options.type the type of the scorecard item currently chosen on
	 * the parent edit form, which may differ from the type in the model
	 * @param options.useSourceTags whether useSourceTags is chosen on the
	 * parent edit form.  May differ from the value in the model.  Only
	 * applicable for linked nodes
	 */
	initialize: function(options) {
		this.options = options || {}
		this.formView = new FormView({ el: this.el, submit: this.submit.bind(this) })
	},

	render: function() {
		this.$el.empty().append(template(this.context()))

		// setup start/archive controls
		this.startSelector = new DateInput({
			el: this.$('.starts-on'),
			initialValue: this.model.get('start')
		}).render()

		this.archiveSelector = new DateInput({
			el: this.$('.archives-on'),
			initialValue: this.model.get('archive'),
			validator : dateRangeValidator.afterDateInput(
				DateInput.dateFormat(), this.startSelector, 'admin.scorecards.startsOn')
		}).render()

		this.startSelector.on('validated', () => this.archiveSelector.validate())

		// MUST be before tags are rendered
		formHelper.writeToDom(this.model, this.el)

		if (this._useSourceTags()) {
			this.$('[name=tags]').parent().addClass('is-not-displayed')
		} else {
			this.tagsChooser = new TagsChooser({
				el: this.$('[name=tags]'),
				tags: this.model.get('tags'),
				globalTags: this.options.globalTags
			}).render()
		}
		if (this._isTemplateCopy()) {
			this.$('.scorecard-tags').addClass('is-not-displayed')
			// #16492 useTemplateDates option
			this.$('.date-settings').removeClass('is-not-displayed')
			this.toggleUseTemplateDates()
			selects(this.$('[name=useTemplateDates]'))
		}

		this.formView.start()

		return this
	},

	toggleUseTemplateDates: function() {
		let useTemplateDates = 'true' === this.$('[name=useTemplateDates]').val()
		this.$('.scorecard-dates').toggleClass('is-not-displayed', useTemplateDates)
	},

	context: function() {
		return _.defaults({
			useSourceTags: this._useSourceTags()
		}, this.options, this.model.attributes)
	},

	_useSourceTags: function() {
		return this.options.type == 'linked' && this.options.useSourceTags
	},

	_isTemplateCopy: function() {
		return _.has(this.options.model.attributes, 'templateId')
	},

	submit: function() {
		this.model.set(formHelper.readFromDom(this.el))
		this.trigger('done')
	},

	remove: function() {
		Backbone.View.prototype.remove.apply(this, arguments)
		_.invokeMap([this.formView, this.startSelector, this.archiveSelector,
			this.tagsChooser], 'remove')
	}

})

export default ScorecardsAdvancedForm

ScorecardsAdvancedForm.__filename__ = 'scorecards/edit/scorecards-advanced-form.js'
